import styled from 'styled-components';
import { Card } from "@mui/material";

export const LoginContainer: any = styled.div<{
    $darkMode?: boolean;
}>`
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw; 
    background: linear-gradient(-45deg, #25a0e2 50%, #00bd9d);

    .loginBgContainer {
        background-image: url(cover-pattern.png);
        background-position: center;
        background-size: cover;
        opacity: 1;
        width: 100%;
        display: flex;
        justify-content: center;
    }
`;

export const StyledCard = styled(Card) <{ $darkMode?: boolean; }>`
    width: max-content;
    height: max-content;
    display: grid;
    grid-template-columns: 400px;
    border-radius: 20px !important;
    align-self: center; 
    padding: 20px 40px;

    .loginFormContainer {
        display: grid;
        grid-template-columns: 1fr;
        justify-content: center;
        margin: 20px 0px;
        align-items: center;
        gap: 10px;

        .formContainer {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            
            img {
                width: 50%;
                marginBottom: 10px;
            }

            .formHeader {
                display: grid;
                grid-template-columns: 1fr auto 1fr;
                margin: 20px 0px 40px 0px;
                gap: 10px;
                width: 70%;
                align-items: center;

                .headerText {
                    font-size: 18px;
                    font-weight: 600;
                }

                .spacer {
                    height: 2px;
                    // background: lightgray;
                    background: #000000de;
                }
            }

            .forgotPasswordLink {
                align-self: flex-end;
                font-size: 13px;
                color: #31a5f1;
                margin: 0px 0px 15px 0px;
                cursor: pointer;
            }

            .loginBtn {
                background: #31a5f1;
                width: 100%;
                height: 40px;
                margin-top: 20px;
                // margin: 20px 0px 40px 0px;
            }

            .loginErrorMessage {
                margin: 10px 0px 0px 0px;
                font-size: 13px;
                font-weight: normal;
                text-align: center;
            }

            .loginErrorMessage.successMessage {
                color: var(--textSuccessColor);
            }

            .loginErrorMessage.errorMessage {
                color: var(--textDangerColor);
            }

            .signUpContainer {
                align-self: center;
                font-size: 13px;
                
                margin: 10px 0px 20px 0px;
                display: grid;
                grid-template-columns: auto auto;
                gap: 5px;

                .signUpLink {
                    color: #31a5f1;
                    cursor: pointer;
                }
            }
        }

        .spacer2 {
            height: 1px;
            background: lightgray;
            // background: #000000de;
        }
    }
`;

export const SignUpContainer: any = styled.div<{
    $darkMode?: boolean;
}>`
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw; 
    background: linear-gradient(-45deg, #25a0e2 50%, #00bd9d);

    .suContainer {
        width: 100%;
        padding: 70px 0px;
        overflow-x: hidden;
        overflow-y: auto;
    
        .signUpBgContainer {
            background-image: url(cover-pattern.png);
            background-position: center;
            background-size: cover;
            opacity: 1;
            width: 100%;
            display: flex;
            justify-content: center;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }
`;

export const SignUpStyledCard = styled(Card) <{ $darkMode?: boolean; }>`
    width: 38%;
    height: max-content;
    display: grid;
    grid-template-columns: 1fr;
    border-radius: 20px !important;
    align-self: center; 
    padding: 20px 40px;

    .signUpFormContainer {
        width:
        display: grid;
        grid-template-columns: 1fr;
        justify-content: center;
        margin: 20px 0px;
        align-items: center;
        gap: 10px;

        .formContainer {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            
            img {
                width: 30%;
                marginBottom: 10px;
            }

            .headerText {
                font-size: 18px;
                font-weight: 600;
                margin: 15px 0px;
            }

            .fieldsContainer {
                width: -webkit-fill-available;
                display: grid;
                grid-template-columns: 1fr 1fr;
                column-gap: 20px;
                row-gap: 15px;
                align-items: start;

                .span2Item {
                    grid-column: span 2;
                }
            }

            .signUpBtn {
                background: #31a5f1;
                width: 100%;
                height: 40px;
                margin-top: 20px;
            }

            .signInContainer {
                align-self: center;
                font-size: 13px;
                
                margin: 10px 0px 20px 0px;
                display: grid;
                grid-template-columns: auto auto;
                gap: 5px;

                .signInLink {
                    color: #31a5f1;
                    cursor: pointer;
                }
            }
        }

        .spacer2 {
            height: 1px;
            background: lightgray;
            // background: #000000de;
        }
    }
`;

export const LogoutContainerContainer: any = styled.div<{
    $darkMode?: boolean;
}>`
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw; 
    background: linear-gradient(-45deg, #25a0e2 50%, #00bd9d);

    .logoutBgContainer {
        background-image: url(cover-pattern.png);
        background-position: center;
        background-size: cover;
        opacity: 1;
        width: 100%;
        display: flex;
        justify-content: center;
    }
`;

export const LogoutStyledCard = styled(Card) <{ $darkMode?: boolean; }>`
    width: 23%;
    height: max-content;
    display: grid;
    grid-template-columns: 1fr;
    border-radius: 20px !important;
    align-self: center; 
    padding: 20px 40px;

    .logoutContainer {
        width:
        display: grid;
        grid-template-columns: 1fr;
        justify-content: center;
        margin: 20px 0px;
        align-items: center;
        gap: 10px;

        .logoutContents {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            
            img {
                width: 55%;
                marginBottom: 10px;
            }

            .headerText {
                font-size: 18px;
                font-weight: 600;
                margin: 30px 0px 0px 0px;
            }

            .thankyouText {
                font-size: 12px;
                font-weight: 400;
            }

            .signInBtn {
                background: #31a5f1;
                width: 100%;
                height: 40px;
                margin: 20px 0px;
            }
        }

        .spacer2 {
            height: 1px;
            background: lightgray;
            // background: #000000de;
        }
    }
`;

export const ForgotPasswordContainer: any = styled.div<{
    $darkMode?: boolean;
}>`
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw; 
    background: linear-gradient(-45deg, #25a0e2 50%, #00bd9d);

    .forgotPasswordBgContainer {
        background-image: url(cover-pattern.png);
        background-position: center;
        background-size: cover;
        opacity: 1;
        width: 100%;
        display: flex;
        justify-content: center;
    }
`;

export const ForgotPasswordStyledCard = styled(Card) <{ $darkMode?: boolean; }>`
    width: 23%;
    height: max-content;
    display: grid;
    grid-template-columns: 1fr;
    border-radius: 20px !important;
    align-self: center; 
    padding: 20px 40px;

    .forgotPasswordFormContainer {
        width:
        display: grid;
        grid-template-columns: 1fr;
        justify-content: center;
        margin: 20px 0px;
        align-items: center;
        gap: 10px;

        .formContainer {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            
            img {
                width: 50%;
                marginBottom: 10px;
            }

            .headerText {
                font-size: 18px;
                font-weight: 600;
                margin: 15px 0px;
            }

            .fieldsContainer {
                width: -webkit-fill-available;
                display: grid;
                grid-template-columns: 1fr;
                column-gap: 20px;
                row-gap: 15px;
                align-items: center;

                .span2Item {
                    grid-column: span 2;
                }
            }

            .resetEmailText {
                font-size: 12px !important;
            }

            .submitBtn {
                background: #31a5f1;
                width: 100%;
                height: 40px;
                margin-top: 20px;
            }

            .goBackLink {
                font-size: 13px;
                font-weight: 600;
                color: #31a5f1;
                cursor: pointer;
                margin: 20px 0px;
            }
        }

        .spacer2 {
            height: 1px;
            background: lightgray;
            // background: #000000de;
        }
    }
`;

export const ResetPasswordContainer: any = styled.div<{
    $darkMode?: boolean;
}>`
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw; 
    background: linear-gradient(-45deg, #25a0e2 50%, #00bd9d);

    .resetPasswordBgContainer {
        background-image: url(cover-pattern.png);
        background-position: center;
        background-size: cover;
        opacity: 1;
        width: 100%;
        display: flex;
        justify-content: center;
    }
`;

export const ResetPasswordStyledCard = styled(Card) <{ $darkMode?: boolean; }>`
    width: 23%;
    height: max-content;
    display: grid;
    grid-template-columns: 1fr;
    border-radius: 20px !important;
    align-self: center; 
    padding: 20px 40px;

    .resetPasswordFormContainer {
        width:
        display: grid;
        grid-template-columns: 1fr;
        justify-content: center;
        margin: 20px 0px;
        align-items: center;
        gap: 10px;

        .formContainer {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            
            img {
                width: 50%;
                marginBottom: 10px;
            }

            .headerText {
                font-size: 18px;
                font-weight: 600;
                margin: 15px 0px 0px 0px;
                line-height: 1;
            }

            .subHeaderText {
                font-size: 12px;
                font-weight: 600;
                margin: 0px 0px 20px 0px;
                line-height: 1;
            }

            .fieldsContainer {
                width: -webkit-fill-available;
                display: grid;
                grid-template-columns: 1fr;
                column-gap: 20px;
                row-gap: 15px;
                align-items: center;

                .span2Item {
                    grid-column: span 2;
                }
            }

            .resetEmailText {
                font-size: 12px !important;
            }

            .submitBtn {
                background: #31a5f1;
                width: 100%;
                height: 40px;
                margin-top: 20px;
            }

            .goBackLink {
                font-size: 13px;
                font-weight: 600;
                color: #31a5f1;
                cursor: pointer;
                margin: 20px 0px;
            }
        }

        .spacer2 {
            height: 1px;
            background: lightgray;
            // background: #000000de;
        }
    }
`;

export const AuthFooterContainer = styled.div`
    margin: 10px 0px 0px 0px;
    justify-content: center;
    align-items: center;
    text-align: center;

    .footerText {
        font-size: 12px;
        color: var(--copyRightTextColor) !important;

        a {
            color: var(--subTextPrimaryColor) !important; 
            font-weight: 500;
            text-decoration: underlined;
            margin: 0px;

            &:hover {
                color: var(--textInfoColor) !important;
            }
        }
    }
`;

export const OTPContainer: any = styled.div<{
    $darkMode?: boolean;
}>`
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw; 
    background: linear-gradient(-45deg, #25a0e2 50%, #00bd9d);

    .otpBgContainer {
        background-image: url(cover-pattern.png);
        background-position: center;
        background-size: cover;
        opacity: 1;
        width: 100%;
        display: flex;
        justify-content: center;
    }
`;

export const OTPStyledCard = styled(Card) <{ $darkMode?: boolean; }>`
    width: 23%;
    height: max-content;
    display: grid;
    grid-template-columns: 1fr;
    border-radius: 20px !important;
    align-self: center; 
    padding: 20px 40px;

    .otpFormContainer {
        width:
        display: grid;
        grid-template-columns: 1fr;
        justify-content: center;
        margin: 20px 0px;
        align-items: center;
        gap: 10px;

        .formContainer {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            
            img {
                width: 50%;
                marginBottom: 10px;
            }

            .headerText {
                font-size: 18px;
                font-weight: 600;
                margin: 15px 0px;
            }

            .subHeaderText {
                font-size: 12px;
                font-weight: 600;
                margin: 0px 0px 20px 0px;
                line-height: 1;
            }

            .fieldsContainer {
                width: -webkit-fill-available;
                display: grid;
                grid-template-columns: 1fr;
                column-gap: 20px;
                // row-gap: 15px;
                align-items: center;

                .recoverAccountLink {
                    // align-self: flex-end;
                    justify-self: end;
                    font-size: 13px;
                    color: #31a5f1;
                    margin: 0px 0px 15px 0px;
                    cursor: pointer;
                }
            }

            .loginErrorMessage {
                margin: 0px 0px 10px 0px;
                font-size: 13px;
                font-weight: normal;
                text-align: center;
            }

            .loginErrorMessage.successMessage {
                color: var(--textSuccessColor);
            }

            .loginErrorMessage.errorMessage {
                color: var(--textDangerColor);
            }

            .submitBtn {
                background: #31a5f1;
                width: 100%;
                height: 40px;
                margin-top: 20px;
            }

            .goBackLink {
                font-size: 13px;
                font-weight: 600;
                color: #31a5f1;
                cursor: pointer;
                margin: 20px 0px;
            }
        }

        .spacer2 {
            height: 1px;
            background: lightgray;
            // background: #000000de;
        }
    }
`;

export const RecoverAccountContainer: any = styled.div<{
    $darkMode?: boolean;
}>`
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw; 
    background: linear-gradient(-45deg, #25a0e2 50%, #00bd9d);

    .recoverAccountBgContainer {
        background-image: url(cover-pattern.png);
        background-position: center;
        background-size: cover;
        opacity: 1;
        width: 100%;
        display: flex;
        justify-content: center;
    }
`;

export const RecoverAccountStyledCard = styled(Card) <{ $darkMode?: boolean; }>`
    width: 23%;
    height: max-content;
    display: grid;
    grid-template-columns: 1fr;
    border-radius: 20px !important;
    align-self: center; 
    padding: 20px 40px;

    .recoverAccountFormContainer {
        width:
        display: grid;
        grid-template-columns: 1fr;
        justify-content: center;
        margin: 20px 0px;
        align-items: center;
        gap: 10px;

        .formContainer {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            
            img {
                width: 50%;
                marginBottom: 10px;
            }

            .headerText {
                font-size: 18px;
                font-weight: 600;
                margin: 15px 0px;
            }

            .subHeaderText {
                font-size: 12px;
                font-weight: 600;
                margin: 0px 0px 20px 0px;
                line-height: 1;
            }

            .fieldsContainer {
                width: -webkit-fill-available;
                display: grid;
                grid-template-columns: 1fr;
                column-gap: 20px;
                // row-gap: 15px;
                align-items: center;

                .emailAddressField {
                    margin: 0px 0px 10px 0px;
                }
            }

            .submitBtn {
                background: #31a5f1;
                width: 100%;
                height: 40px;
                margin-top: 20px;
            }

            .goBackLink {
                font-size: 13px;
                font-weight: 600;
                color: #31a5f1;
                cursor: pointer;
                margin: 20px 0px;
            }

            .recoverAccountLink {
                // align-self: flex-end;
                justify-self: end;
                font-size: 13px;
                color: #31a5f1;
                margin: 0px 0px 15px 0px;
                cursor: pointer;
            }
        }

        .spacer2 {
            height: 1px;
            background: lightgray;
            // background: #000000de;
        }
    }
`;